import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { teamUseMutation } from "../hooks";
import TeamConst from "../team-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import Icons from "components/icons";
import { usePermissionByObject, useModelFormValidation } from "components/permissions";
import Team from "components/team";


interface ITeamActionFieldProps
{
  teamId: string;
  teamName: string;
}

const TeamActionField: React.FC<ITeamActionFieldProps> = ({ teamId, teamName }) =>
{
  const navigate = useNavigate();

  const { _setMutationTeamDelete, loadingMutationTeamDelete } =
    teamUseMutation.delete(teamId);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Team.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Team.Const.permissions.DELETE);
  const { validateDeletePermission } = useModelFormValidation(Team.Const);

  const items = [
    {
      label: (
        <Tooltip
          title={!hasUpdatePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Team.Const.permissions.UPDATE.slug)}` : undefined}
        >
          <span style={{ display: "flex", alignItems: "center", width: 100 }}>
            <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      onClick: () => {
        if (!hasUpdatePermission) return;
        navigate(`${TeamConst.basePath}/${teamId}`);
      },
      disabled: !hasUpdatePermission,
    },
    {
      key: "2",
      label: (
        <Tooltip
          title={!hasDeletePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Team.Const.permissions.DELETE.slug)}` : undefined}
        >
          <EntityRemoveButton
            modalButton={
              <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_Team")
            }
            dataNameEntity={teamName}
            loading={loadingMutationTeamDelete}
            deleteMutation={(options) =>
            {
              if (!validateDeletePermission()) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationTeamDelete(options);
            }}
            variables={{
              id: teamId,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default TeamActionField;
